// İSG uzmanı portalı — İş İzni Tipleri (Permit Types) erişim kapısı (route guard UX).
//
// Asıl yetki backend'dedir (`[ModuleAction("permit-types", …)]`); bu kapı yalnız UX'tir: erişim
// sondasının (usePermitTypesAccess) sonucuna göre İş İzni Tipleri kabuğunu (`PermitTypesShell`,
// owner review B2 item 7 — Admin/Ayarlar/Ziyaretçiler kapılarıyla AYNI desen), 403 sayfasını
// veya "kullanılamıyor" durumunu gösterir. Firma admin ayar modülü olarak AYRIDIR (gerçek
// Value = `permit-types`).

import { Button, Card, CardContent, Spinner } from '@isgportal/shared';
import { ListChecks, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { usePermitTypesAccess } from '../../lib/permitTypesAccess';
import { PermitTypesShell } from './PermitTypesShell';

export function PermitTypesGate() {
  const { t } = useTranslation();
  const access = usePermitTypesAccess();

  if (access.status === 'loading') {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Spinner label={t('permitTypes.gate.loadingLabel')} />
      </div>
    );
  }

  if (access.status === 'forbidden') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <ListChecks className="h-10 w-10 text-danger" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('permitTypes.forbidden.title')}</h1>
              <p className="text-sm text-muted">{t('permitTypes.forbidden.body')}</p>
            </div>
            <Button asChild variant="secondary">
              <Link to="/">{t('permitTypes.forbidden.back')}</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (access.status === 'unavailable') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <TriangleAlert className="h-10 w-10 text-warning-foreground" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">
                {t('permitTypes.unavailable.title')}
              </h1>
              <p className="text-sm text-muted">{t('permitTypes.unavailable.body')}</p>
            </div>
            <Button onClick={access.refetch}>{t('permitTypes.unavailable.retry')}</Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <PermitTypesShell />;
}
